import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black'
};
const ModalComponent = (props) => {

    const { text, api } = props
    const { deleteAnexo, inputField } = api

    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }}>
                            <center><strong>{titleModal}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black" , textAlign: 'justify'}}>
                            {bodyModal}
                            <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row col-md-12'>
                            <div className='col-md-6'>
                                <button className='btn btn-danger'style={{width: '100%'}} onClick={() => {
                                    switch (accion) {
                                        case 'eliminar':
                                            botonEliminarAnexo()
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                }>CONTINUAR</button>
                            </div>
                            <div className='col-md-6'>
                                <button className={`btn btn-dark`} type='button' style={{width: '100%'}} onClick={() => handleCloseModal()}>CANCELAR</button>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    const botonEliminar = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de eliminar ${text}, esta acción no se podrá revertir.`,
            accion: 'eliminar',
        })
    }

    const botonEliminarAnexo = async () => {
        deleteAnexo(inputField)
        setOpenModal(false)
    }
    return (
        <Fragment>
            <button className='botonEliminarAnexo mt-2 btn btn-xs' onClick={e =>
                botonEliminar()} >Eliminar</button>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(ModalComponent)
